import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import { DateField } from 'components/forms';
import { selectSettings } from 'store/slices/authSlice';

export default function OneTimeDateStep() {
  const { nextStep, data } = useWizard();
  const settings = useSelector(selectSettings);
  const { control, handleSubmit } = useForm({
    defaultValues: {
      executionDate: data.schedule?.executionDate || null
    }
  });

  const onSubmit = (formData) => {
    nextStep({
      schedule: {
        ...data.schedule,
        executionDate: formData.executionDate
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <WizardStepLayout
        title="Select Date & Time"
        description="When should this reminder be sent?"
        primaryAction={{ label: 'Next', type: 'submit' }}
      >
        <div className="max-w-md mx-auto">
          <Controller
            name="executionDate"
            control={control}
            rules={{ required: 'Date is required' }}
            render={({ field, fieldState: { error } }) => (
              <DateField
                label="Date & Time"
                showTime
                disablePast
                dateFormat={settings?.dateFormat}
                timeFormat={settings?.timeFormat}
                error={error?.message}
                {...field}
              />
            )}
          />
        </div>
      </WizardStepLayout>
    </form>
  );
}
